import { render, staticRenderFns } from "./BookingIncidents.vue?vue&type=template&id=242783fc&"
import script from "./BookingIncidents.vue?vue&type=script&lang=js&"
export * from "./BookingIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports